// ISO 3166-1 alpha-2 ölkə kodları + AZ ad + bayraq emoji.
// Default: AZ (Azerbaijan).
export const COUNTRIES = [
  { code: "AZ", name: "Azərbaycan", flag: "🇦🇿" },
  { code: "TR", name: "Türkiyə", flag: "🇹🇷" },
  { code: "RU", name: "Rusiya", flag: "🇷🇺" },
  { code: "GE", name: "Gürcüstan", flag: "🇬🇪" },
  { code: "UA", name: "Ukrayna", flag: "🇺🇦" },
  { code: "KZ", name: "Qazaxıstan", flag: "🇰🇿" },
  { code: "US", name: "ABŞ", flag: "🇺🇸" },
  { code: "GB", name: "Birləşmiş Krallıq", flag: "🇬🇧" },
  { code: "DE", name: "Almaniya", flag: "🇩🇪" },
  { code: "FR", name: "Fransa", flag: "🇫🇷" },
  { code: "IT", name: "İtaliya", flag: "🇮🇹" },
  { code: "ES", name: "İspaniya", flag: "🇪🇸" },
  { code: "NL", name: "Hollandiya", flag: "🇳🇱" },
  { code: "BE", name: "Belçika", flag: "🇧🇪" },
  { code: "CH", name: "İsveçrə", flag: "🇨🇭" },
  { code: "AT", name: "Avstriya", flag: "🇦🇹" },
  { code: "SE", name: "İsveç", flag: "🇸🇪" },
  { code: "NO", name: "Norveç", flag: "🇳🇴" },
  { code: "DK", name: "Danimarka", flag: "🇩🇰" },
  { code: "FI", name: "Finlandiya", flag: "🇫🇮" },
  { code: "PL", name: "Polşa", flag: "🇵🇱" },
  { code: "CZ", name: "Çexiya", flag: "🇨🇿" },
  { code: "HU", name: "Macarıstan", flag: "🇭🇺" },
  { code: "RO", name: "Rumıniya", flag: "🇷🇴" },
  { code: "BG", name: "Bolqarıstan", flag: "🇧🇬" },
  { code: "GR", name: "Yunanıstan", flag: "🇬🇷" },
  { code: "PT", name: "Portuqaliya", flag: "🇵🇹" },
  { code: "IE", name: "İrlandiya", flag: "🇮🇪" },
  { code: "IS", name: "İslandiya", flag: "🇮🇸" },
  { code: "EE", name: "Estoniya", flag: "🇪🇪" },
  { code: "LV", name: "Latviya", flag: "🇱🇻" },
  { code: "LT", name: "Litva", flag: "🇱🇹" },
  { code: "BY", name: "Belarus", flag: "🇧🇾" },
  { code: "MD", name: "Moldova", flag: "🇲🇩" },
  { code: "AM", name: "Ermənistan", flag: "🇦🇲" },
  { code: "IR", name: "İran", flag: "🇮🇷" },
  { code: "IQ", name: "İraq", flag: "🇮🇶" },
  { code: "SA", name: "Səudiyyə Ərəbistanı", flag: "🇸🇦" },
  { code: "AE", name: "BƏƏ", flag: "🇦🇪" },
  { code: "QA", name: "Qatar", flag: "🇶🇦" },
  { code: "KW", name: "Küveyt", flag: "🇰🇼" },
  { code: "BH", name: "Bəhreyn", flag: "🇧🇭" },
  { code: "OM", name: "Oman", flag: "🇴🇲" },
  { code: "JO", name: "İordaniya", flag: "🇯🇴" },
  { code: "LB", name: "Livan", flag: "🇱🇧" },
  { code: "SY", name: "Suriya", flag: "🇸🇾" },
  { code: "IL", name: "İsrail", flag: "🇮🇱" },
  { code: "EG", name: "Misir", flag: "🇪🇬" },
  { code: "MA", name: "Mərakeş", flag: "🇲🇦" },
  { code: "DZ", name: "Əlcəzair", flag: "🇩🇿" },
  { code: "TN", name: "Tunis", flag: "🇹🇳" },
  { code: "LY", name: "Liviya", flag: "🇱🇾" },
  { code: "ZA", name: "Cənubi Afrika", flag: "🇿🇦" },
  { code: "NG", name: "Nigeriya", flag: "🇳🇬" },
  { code: "KE", name: "Keniya", flag: "🇰🇪" },
  { code: "ET", name: "Efiopiya", flag: "🇪🇹" },
  { code: "CN", name: "Çin", flag: "🇨🇳" },
  { code: "JP", name: "Yaponiya", flag: "🇯🇵" },
  { code: "KR", name: "Cənubi Koreya", flag: "🇰🇷" },
  { code: "IN", name: "Hindistan", flag: "🇮🇳" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰" },
  { code: "BD", name: "Banqladeş", flag: "🇧🇩" },
  { code: "ID", name: "İndoneziya", flag: "🇮🇩" },
  { code: "TH", name: "Tayland", flag: "🇹🇭" },
  { code: "VN", name: "Vyetnam", flag: "🇻🇳" },
  { code: "MY", name: "Malayziya", flag: "🇲🇾" },
  { code: "SG", name: "Sinqapur", flag: "🇸🇬" },
  { code: "PH", name: "Filippin", flag: "🇵🇭" },
  { code: "AU", name: "Avstraliya", flag: "🇦🇺" },
  { code: "NZ", name: "Yeni Zelandiya", flag: "🇳🇿" },
  { code: "CA", name: "Kanada", flag: "🇨🇦" },
  { code: "MX", name: "Meksika", flag: "🇲🇽" },
  { code: "BR", name: "Braziliya", flag: "🇧🇷" },
  { code: "AR", name: "Argentina", flag: "🇦🇷" },
  { code: "CL", name: "Çili", flag: "🇨🇱" },
  { code: "PE", name: "Peru", flag: "🇵🇪" },
  { code: "CO", name: "Kolumbiya", flag: "🇨🇴" },
  { code: "VE", name: "Venesuela", flag: "🇻🇪" },
  { code: "UY", name: "Uruqvay", flag: "🇺🇾" },
  { code: "EC", name: "Ekvador", flag: "🇪🇨" },
  { code: "CU", name: "Kuba", flag: "🇨🇺" },
];

export const DEFAULT_COUNTRY = "AZ";

export function getCountry(code) {
  return COUNTRIES.find((c) => c.code === (code || "").toUpperCase()) || null;
}
